import Layout from '@/layout'

const route = {
  path: '/copyReleaseGroup',
  component: Layout,
  redirect: '/copyReleaseGroup/index',
  alwaysShow: true, // will always show the root menu
  name: 'releaseGroup',
  meta: {
    title: 'IAA小说报表',
    icon: 'IAA',
    roles: [
      'mini_program_report.management'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/copyReleaseGroup/releaseGroupList/index',
      component: () => import('@/views/copyReleaseGroup/releaseGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '投放组列表',
        icon: 'component',
        roles: [
          'mini_program_report.release_group.index'
        ]
      }
    },
    {
      path: '/copyReleaseGroup/operations/index',
      component: () => import('@/views/copyReleaseGroup/operations/index.vue'),
      name: 'operations',
      meta: {
        title: '运营组列表',
        icon: 'component',
        roles: [
          'mini_program_report.operation_group.index'
        ]
      }
    },
    {
      path: '/copyReleaseGroup/bookOwnership/index',
      component: () => import('@/views/copyReleaseGroup/bookOwnership/index.vue'),
      name: 'bookOwnership',
      meta: {
        title: '书籍归属列表',
        icon: 'component',
        roles: [
          'mini_program_report.belong_list'
        ]
      }
    },
    {
      path: '/copyReleaseGroup/dropLocationList/index',
      component: () => import('@/views/copyReleaseGroup/dropLocationList/index.vue'),
      name: 'dropLocationList',
      meta: {
        title: '投放位置列表',
        icon: 'component',
        roles: [
          'mini_program_report.positions.index'
        ]
      }
    },
    {
      path: '/copyReleaseGroup/bindingRelationList/index',
      component: () => import('@/views/copyReleaseGroup/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系列表',
        icon: 'component',
        roles: [
          'mini_program_report.bind_wechat.index'
        ]
      }
    }, {
      path: '/copyReleaseGroup/reportList/index',
      component: () => import('@/views/copyReleaseGroup/reportList/index.vue'),
      name: 'reportList',
      meta: {
        title: '报表列表',
        icon: 'component',
        roles: [
          'mini_program_report.bind_wechat_report'
        ]
      }
    }, {
      path: '/copyReleaseGroup/totalReportList/index',
      component: () => import('@/views/copyReleaseGroup/totalReportList/index.vue'),
      name: 'totalReportList',
      meta: {
        title: '总计报表',
        icon: 'component',
        roles: [
          'mini_program_report.bind_wechat_total_report'
        ]
      }
    }
    // , {
    //   path: '/copyReleaseGroup/reportForm/index',
    //   component: () => import('@/views/copyReleaseGroup/reportForm/index.vue'),
    //   name: 'reportForm',
    //   meta: {
    //     title: 'T图列表',
    //     icon: 'component',
    //     roles: [
    //       'release_report.bind_wechat_t_report'
    //     ]
    //   }
    // }
  ]
}

export default route
